import {
  Link
} from 'react-router-dom'
const LinkField = ({ link, record, source, label }) => <div style={{ display: 'flex', padding: '8px 0px' }}>
  <div style={{ width: 210, marginRight: 8 }}><span style={{ fontWeight: '700' }}>{label}</span></div>
  <div><Link to={link}>{record[source]}</Link></div>
</div>

export default LinkField;